export default [
    // Models
    {
        name: 'ramenShopModel',
        type: 'gltfModel',
        path: 'models/ramenShop/glTF/ramenShop.gltf'
    },
    {
        name: 'ramenHologram',
        type: 'gltfModel',
        path: 'models/ramenShop/glTF/ramenHologram.gltf'
    },
    // Baked Textures
    {
        name: 'ramenShopBakedTexture',
        type: 'KTX2Texture',
        path: 'textures/baked/ramenShopBaked1024.ktx2'
    },
    {
        name: 'machinesBakedTexture',
        type: 'KTX2Texture',
        path: 'textures/baked/machinesBaked1024.ktx2'
    },

    {
        name: 'floorBakedTexture',
        type: 'KTX2Texture',
        path: 'textures/baked/floorBaked1024.ktx2'
    },

    {
        name: 'miscBakedTexture',
        type: 'KTX2Texture',
        path: 'textures/baked/miscBaked1024.ktx2'
    },

    {
        name: 'graphicsBakedTexture',
        type: 'KTX2Texture',
        path: 'textures/baked/graphicsBaked512.ktx2'
    },
    // Matcaps
    {
        name: 'dishMatcapTexture',
        type: 'KTX2Texture',
        path: 'textures/matcaps/dishMatCap.ktx2'
    },
    {
        name: 'fanMatcapTexture',
        type: 'KTX2Texture',
        path: 'textures/matcaps/fanMatCap.ktx2'
    },
    {
        name: 'lightMatcapTexture',
        type: 'texture',
        path: 'textures/matcaps/lightMatcap.png'
    },
    {
        name: 'neonBlueMatcapTexture',
        type: 'KTX2Texture',
        path: 'textures/matcaps/neonBlueMatCap.ktx2'
    },
    {
        name: 'neonGreenMatcapTexture',
        type: 'KTX2Texture',
        path: 'textures/matcaps/neonGreenMatCap.ktx2'
    },
    // Arcade Screens
    {
        name: 'arcadeScreenDefaultTexture',
        type: 'KTX2Texture',
        path: 'textures/screens/arcadeScreens/arcadeScreenDefault.ktx2'
    },

    {
        name: 'arcadeScreenCreditsTexture',
        type: 'KTX2Texture',
        path: 'textures/screens/arcadeScreens/arcadeScreenCredits.ktx2'
    },

    {
        name: 'arcadeScreenThanksTexture',
        type: 'KTX2Texture',
        path: 'textures/screens/arcadeScreens/arcadeScreenThanks.ktx2'
    },

    // Easel
    {
        name: 'easelTouchTexture',
        type: 'KTX2Texture',
        path: 'textures/screens/easel/easelTouch.ktx2'
    },

    {
        name: 'easelClickTexture',
        type: 'KTX2Texture',
        path: 'textures/screens/easel/easelClick.ktx2'
    },
    

    // About Me Screens
    {
        name: 'bigScreenDefaultTexture',
        type: 'KTX2Texture',
        path: 'textures/screens/aboutMeScreens/bigScreenDefault.ktx2'
    },

    {
        name: 'bigScreenAboutMeTexture',
        type: 'texture',
        path: 'textures/screens/aboutMeScreens/bigScreenAbout.png'
    },

    {
        name: 'bigScreenSkillsTexture',
        type: 'KTX2Texture',
        path: 'textures/screens/aboutMeScreens/bigScreenSkills.ktx2'
    },

    {
        name: 'bigScreenExperienceTexture',
        type: 'KTX2Texture',
        path: 'textures/screens/aboutMeScreens/bigScreenExperience.ktx2'
    },

    {
        name: 'bigScreenAboutMeMobileTexture',
        type: 'texture',
        path: 'textures/screens/aboutMeScreens/bigScreenAboutMobile.png'
    },

    {
        name: 'bigScreenSkillsMobileTexture',
        type: 'KTX2Texture',
        path: 'textures/screens/aboutMeScreens/bigScreenSkillsMobile.ktx2'
    },

    {
        name: 'bigScreenExperienceMobileTexture',
        type: 'KTX2Texture',
        path: 'textures/screens/aboutMeScreens/bigScreenExperienceMobile.ktx2'
    },

    // Projects
    {
        name: 'vendingMachineDefaultTexture',
        type: 'KTX2Texture',
        path: 'textures/screens/vendingMachineScreens/vendingMachineDefault.ktx2'
    },

    {
        name: 'vendingMachineMenuTexture',
        type: 'KTX2Texture',
        path: 'textures/screens/vendingMachineScreens/vendingMachineMenu.ktx2'
    },


    {
        name: 'project1Texture',
        type: 'KTX2Texture',
        path: 'textures/screens/vendingMachineScreens/project1.ktx2'
    },

    {
        name: 'project2Texture',
        type: 'KTX2Texture',
        path: 'textures/screens/vendingMachineScreens/project2.ktx2'
    },

    {
        name: 'project3Texture',
        type: 'KTX2Texture',
        path: 'textures/screens/vendingMachineScreens/project3.ktx2'
    },

    {
        name: 'project4Texture',
        type: 'KTX2Texture',
        path: 'textures/screens/vendingMachineScreens/project4.ktx2'
    },

    {
        name: 'project5Texture',
        type: 'KTX2Texture',
        path: 'textures/screens/vendingMachineScreens/project5.ktx2'
    },

    {
        name: 'project6Texture',
        type: 'KTX2Texture',
        path: 'textures/screens/vendingMachineScreens/project6.ktx2'
    },

    {
        name: 'project7Texture',
        type: 'KTX2Texture',
        path: 'textures/screens/vendingMachineScreens/project7.ktx2'
    },

    {
        name: 'project8Texture',
        type: 'KTX2Texture',
        path: 'textures/screens/vendingMachineScreens/project8.ktx2'
    },


    // Videos
    {
        name: 'littleTVScreenVideoTexture',
        type: 'videoTexture',
        path: 'textures/videosTextures/littleTVScreen.mp4'
    },
    {
        name: 'tallScreenVideoTexture',
        type: 'videoTexture',
        path: 'textures/videosTextures/tallScreen.mp4'
    },
    {
        name: 'tvScreenVideoTexture',
        type: 'videoTexture',
        path: 'textures/videosTextures/tvScreen.mp4'
    },
    {
        name: 'smallScreen5VideoTexture',
        type: 'videoTexture',
        path: 'textures/videosTextures/smallScreen5.mp4'
    },
    {
        name: 'smallScreen4VideoTexture',
        type: 'videoTexture',
        path: 'textures/videosTextures/smallScreen4.mp4'
    },
    {
        name: 'smallScreen3VideoTexture',
        type: 'videoTexture',
        path: 'textures/videosTextures/smallScreen3.mp4'
    },

    // smallScreen1 carousel

    {
        name: 'smallScreenOne1',
        type: 'basisTexture',
        path: 'textures/screens/smallScreen1/1.basis'
    },
    {
        name: 'smallScreenOne2',
        type: 'basisTexture',
        path: 'textures/screens/smallScreen1/2.basis'
    },
    {
        name: 'smallScreenOne3',
        type: 'basisTexture',
        path: 'textures/screens/smallScreen1/3.basis'
    },
    {
        name: 'smallScreenOne4',
        type: 'basisTexture',
        path: 'textures/screens/smallScreen1/4.basis'
    },
    {
        name: 'smallScreenOne5',
        type: 'basisTexture',
        path: 'textures/screens/smallScreen1/5.basis'
    },

    // smallScreen2 carousel

    {
        name: 'smallScreenTwo1',
        type: 'basisTexture',
        path: 'textures/screens/smallScreen2/1.basis'
    },
    {
        name: 'smallScreenTwo2',
        type: 'basisTexture',
        path: 'textures/screens/smallScreen2/2.basis'
    },
    {
        name: 'smallScreenTwo3',
        type: 'basisTexture',
        path: 'textures/screens/smallScreen2/3.basis'
    },
    {
        name: 'smallScreenTwo4',
        type: 'basisTexture',
        path: 'textures/screens/smallScreen2/4.basis'
    },
    {
        name: 'smallScreenTwo5',
        type: 'basisTexture',
        path: 'textures/screens/smallScreen2/5.basis'
    },

    // sideScreen

    {
        name: 'sideScreen1Texture',
        type: 'KTX2Texture',
        path: 'textures/screens/sideScreens/sideScreen1.ktx2'
    },
    {
        name: 'sideScreen2Texture',
        type: 'KTX2Texture',
        path: 'textures/screens/sideScreens/sideScreen2.ktx2'
    },
    {
        name: 'sideScreen3Texture',
        type: 'KTX2Texture',
        path: 'textures/screens/sideScreens/sideScreen3.ktx2'
    }
]